import { HTTPClient } from "../utils/request";

export default {
  index: () => HTTPClient.get(`/shippers`),
  store: ({ payload }) => HTTPClient.post(`/shippers`, payload),
  update: ({ payload, params }) => HTTPClient.put(`/shippers/${params._id}`, payload),
  show: ({ params }) => HTTPClient.get(`/shippers/${params._id}`),
  destroy: ({ params }) =>  HTTPClient.delete(`shippers/${params._id}`)
};
